import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template", "empty"]

  connect() {
    this.updateEmpty()
  }

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/__INDEX__/g, Date.now())
    this.listTarget.insertAdjacentHTML("beforeend", content)
    this.updateEmpty()
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-source-row]")
    const destroyField = row.querySelector("input[name$='[_destroy]']")
    if (destroyField) {
      destroyField.value = "1"
      row.classList.add("hidden")
    } else {
      row.remove()
    }
    this.updateEmpty()
  }

  updateEmpty() {
    const rows = this.listTarget.querySelectorAll("[data-source-row]:not(.hidden)")
    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", rows.length > 0)
    }
  }
}
